/**
 * Calm daily focus suggestions for Vandaag (spec §8.1).
 *
 * The suggestion rotates deterministically by local date: the same date always
 * shows the same text, on every device, without any network or personal data.
 * Copy is deliberately generic — no health claims, no fake personalization.
 */

export const DAILY_FOCUS_SUGGESTIONS: readonly string[] = [
  'Kies één ding dat je vandaag rust geeft en begin daarmee.',
  'Doe één taak tegelijk. De rest komt later aan de beurt.',
  'Plan een korte pauze voor jezelf, ook al is het maar vijf minuten.',
  'Leg spullen terug op hun vaste plek — dat scheelt later zoeken.',
  'Schrijf op wat je niet wilt vergeten, dan hoeft het niet in je hoofd te blijven.',
  'Begin rustig: adem een paar keer diep in en uit voordat je start.',
  'Iets kleins afmaken telt ook. Kies een kleine stap en rond die af.',
  'Ruim één klein plekje op. Een leeg hoekje geeft al overzicht.',
  'Kijk aan het eind van de dag naar wat er wél gelukt is.',
  'Zet je telefoon een half uur aan de kant en merk hoe dat voelt.',
  'Vraag hulp als iets te groot voelt. Dat is een sterke stap.',
  'Houd het simpel vandaag: drie dingen op je lijstje zijn genoeg.',
]

function hashDate(isoDate: string): number {
  let hash = 0
  for (let index = 0; index < isoDate.length; index += 1) {
    hash = (hash * 31 + isoDate.charCodeAt(index)) % 9973
  }
  return hash
}

/** Deterministic focus index for a local ISO date (yyyy-mm-dd). */
export function focusIndexForDate(isoDate: string, count: number = DAILY_FOCUS_SUGGESTIONS.length): number {
  if (count <= 0) return 0
  return hashDate(isoDate) % count
}

/** The calm focus suggestion for the given local ISO date. */
export function focusForDate(isoDate: string): string {
  return DAILY_FOCUS_SUGGESTIONS[focusIndexForDate(isoDate)]
}
